import { ButtonsPosition, ClearButton } from 'components/common/button/button';
import ArrowLeftIcon from 'components/icons/ArrowLeftIcon';

import { STEPS } from 'lib/constants';
import { getStep } from 'utils';

const RetireBackButton = ({ action }) => {
  const [step, setStep] = action;

  if (step === STEPS.CHOOSE_PROJECTS) return null;

  return (
    <ButtonsPosition position="left">
      <ClearButton onClick={() => setStep(getStep(step, -1, STEPS))}>
        <ArrowLeftIcon />
      </ClearButton>
    </ButtonsPosition>
  );
};

export default RetireBackButton;
